import { render } from "./profitandloss.vue?vue&type=template&id=2bc8e603"
import script from "./profitandloss.vue?vue&type=script&lang=js"
export * from "./profitandloss.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__